/**
 * 删除类操作的统一二次确认
 *
 * 规则（全项目强制）：任何「删除 / 移除已上传内容」的操作，必须先弹确认框，
 * 不能点了就删——上传耗时且文件较大，误删要重新上传。
 *
 * 用法：
 *   if (!(await confirmRemove('确定删除这张配图吗？'))) return
 */
import { showConfirm } from '@/composables/useToast'

/**
 * @param content 确认正文
 * @param title 标题，默认「删除确认」
 * @returns Promise<boolean> true 表示用户确认删除
 */
export function confirmRemove(content: string, title = '删除确认'): Promise<boolean> {
  return showConfirm({ title, content, confirmText: '删除', cancelText: '取消', danger: true })
}

/**
 * 通用确认（非删除场景，如退出登录、清空缓存）
 */
export function confirmAction(content: string, title = '提示', confirmText = '确定'): Promise<boolean> {
  return showConfirm({ title, content, confirmText, cancelText: '取消', danger: false })
}
